import { type paths } from 'src/api/generated/checkout-widgets';

type AssertNever<Value extends never> = Value;
type PostComposedWebOperation = paths['/web']['post'];
type PostComposedWebParameters = PostComposedWebOperation['parameters'];
type PostComposedWebHeaders = PostComposedWebParameters['header'];

const BROWSER_MANAGED_HEADERS = [
  'Referer',
] as const satisfies readonly (keyof PostComposedWebHeaders)[];

export type CheckoutWidgetsUnexpectedApplicationHeader = AssertNever<
  Exclude<
    keyof PostComposedWebHeaders,
    (typeof BROWSER_MANAGED_HEADERS)[number]
  >
>;
export type CheckoutWidgetsMissingResponseStatus = AssertNever<
  Exclude<200 | 204 | 'default', keyof PostComposedWebOperation['responses']>
>;
export type CheckoutWidgetsUnexpectedResponseStatus = AssertNever<
  Exclude<keyof PostComposedWebOperation['responses'], 200 | 204 | 'default'>
>;

export type PostComposedWebRequestBody =
  PostComposedWebOperation['requestBody']['content']['application/json'];
export type PostComposedWebResponseBody =
  PostComposedWebOperation['responses'][200]['content']['application/json'];
export type PostComposedWebTransport = (
  input: RequestInfo | URL,
  init?: RequestInit
) => Promise<Response>;

export const POST_COMPOSED_WEB_OPERATION = {
  method: 'POST',
  path: '/web' satisfies keyof paths,
  requestMediaType: 'application/json',
} as const;

export const postComposedWeb = (
  baseUrl: string,
  body: PostComposedWebRequestBody,
  options: {
    readonly signal?: AbortSignal;
    readonly transport?: PostComposedWebTransport;
  } = {}
) => {
  const transport = options.transport ?? fetch;

  return transport(`${baseUrl}${POST_COMPOSED_WEB_OPERATION.path}`, {
    method: POST_COMPOSED_WEB_OPERATION.method,
    headers: {
      'Content-Type': POST_COMPOSED_WEB_OPERATION.requestMediaType,
    },
    body: JSON.stringify(body),
    signal: options.signal,
  });
};
